import { SlickGridProperties } from 'app/shared/models/slick-grid-properties';
export class SlickGridColumns {
    public data: SlickGridProperties[][];
    constructor(public tableName: string, data: SlickGridProperties[], index?: number) {
        if (index === undefined) index = 0;
        this.data = [];

        if (index > 0) {
            for (let i = 0; i < index; i++){
                this.data[i] = []
            }
        }

        this.data[index] = data;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/slick-grid-columns.ts